<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
  name: "App",
  data() {
    return {
      zh_CN,
    };
  },
};
</script>

<style>

  .ant-modal-wrap.custom-modal-wrap {
    overflow: hidden !important; /* 隐藏溢出滚动条 */
  }

  .ant-modal-wrap.custom-modal-wrap .ant-modal {
    position: fixed !important; /* 保持 fixed 定位 */
    margin: 0;
    top: 2%;
    left: 34%;
  }
html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
.panel .ant-table {
  min-height: 220px !important;
}
</style>
